@if (loading()) {
  <app-progress-spinner />
} @else {
  <ng-content></ng-content>
}
